export const PRODUCT_DESCRIPTION = 'pdp.accordion.description';
export const FLAVORS_BREAKDOWN_WARNING = 'pdp.accordion.flavors.warning';
export const FLAVORS_BREAKDOWN_VIEW_MORE = 'pdp.accordion.flavors.viewMore';
export const FLAVORS_BREAKDOWN_VIEW_LESS = 'pdp.accordion.flavors.viewLess';
export const QUESTIONS = 'pdp.accordion.questions';
export const COUPONS_APPLICABLE_TITLE = 'pdp.coupons.applicable.title';
export const ALLERGY_WARNING_TITLE = 'pdp.allergy.warning.title';
export const DISCLAIMER_TITLE = 'pdp.disclaimer.warning.title';
